// src/components/Dashboard/ClubCoordinator/ClubCoordinatorHome.js
import React from 'react';
import './ClubCoordinator.css';

const ClubCoordinatorHome = () => {
  return (
    <div className="coordinator-home">
      <h3>Welcome to Club Coordinator Dashboard</h3>
      <div className="welcome-content">
        <p>This dashboard allows you to manage approved member and partner applications.</p>
        
        <div className="feature-cards">
          <div className="feature-card">
            <h4>Member Applications</h4>
            <p>View and manage all approved member applications. Download PDF reports and update approver information.</p>
          </div>
          
          <div className="feature-card">
            <h4>Partner Applications</h4>
            <p>View and manage all approved partner applications. Export data to CSV and process partnership details.</p>
          </div>
          
          <div className="feature-card">
            <h4>All Applications</h4>
            <p>See a combined view of all approved applications in one place for comprehensive oversight.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClubCoordinatorHome;